export default __webpack_public_path__ + "videos/particle-glow-trail-silver-1440w.5968b6332d1221d420644a38c6321444.mp4";